import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import './CitiesList.css';
import Button from '../../components/Button';
import { Checkbox } from '../../components/Input';
import { connect } from 'react-redux';
import { setCity, setCityPrepositional, setCityID, setCityPhone, setCitySelected, clear } from "../../actions/SetCity";
import { setFilterData } from "../../actions/FiltersActions";
import { modalClose } from "../../actions/ModalActions";

class CitiesList extends Component {
  componentDidMount = () => {
    this.selectedCheckboxes = [];
  }

  handleCityClick = (e, name, prepositional, id, phone) => {
    e.preventDefault();
    this.props.handleCityClick(name, prepositional, id, phone);
  }

  toggleCheckbox = (label, id) => {
    if (this.props.baseCity.baseCityID === id) {
      const item = this.selectedCheckboxes.filter(o => this.props.baseCity.baseCityID === id);
      this.props.handleCityChange(item.name, item.name_prepositional, item.id, item.phone)
    } else if (this.selectedCheckboxes.find(o => o.id === id)) {
      this.selectedCheckboxes.splice(this.selectedCheckboxes.findIndex(o => o.id === id), 1);
    } else {
      this.selectedCheckboxes.push({label, id});
    }


    if (this.props.baseCity.baseCityID === undefined || this.props.baseCity.baseCityPrepositional === 'во всех городах') {
      const item = this.props.cities.filter(o => o.id === id);
      this.props.handleCityChange(item[0].name, item[0].name_prepositional, item[0].id, item[0].phone)
    }
  }

  handleCitiesClick = e => {
    e.preventDefault();
    const id = this.props.baseCity.baseCityID
    const label = this.props.baseCity.baseCityName
    if (!this.selectedCheckboxes.length) {
      let FilterCities = this.props.cities
        .filter((item) => item.name.toLowerCase() === 'вся россия')
      this.props.handleCityChange(FilterCities[0].name, FilterCities[0].name_prepositional, FilterCities[0].id, FilterCities[0].phone)
    } else if(!this.props.baseCity.baseCityID) {
      const city = this.props.cities.filter(o => o.id === this.selectedCheckboxes[0].id);
      this.props.handleCityChange(city[0].name, city[0].name_prepositional, city[0].id, city[0].phone)
    } else {
      this.selectedCheckboxes.push({id, label});
    }

    this.selectedCheckboxes.forEach(el => {
      if(el.label.toLowerCase() === 'удаленная работа') {
        this.selectedCheckboxes = [el];
        const city = this.props.cities.filter(o => o.id === el.id);
        this.props.handleCityChange(city[0].name, city[0].name_prepositional, city[0].id, city[0].phone)
      }
    })
    // console.log('123', this.selectedCheckboxes);
    this.props.handleCitiesClick(this.selectedCheckboxes);
  }

  handleAllCitiesClick = e => {
    e.preventDefault();
    this.props.handleAllCitiesClick();
  }

  render() {
    var SortingCities = this.props.cities
      .filter((item) => !(item.name.toLowerCase() === 'удаленная работа' || item.name.toLowerCase() === 'вся россия'))
      .sort((a,b) => {
        return a.name.localeCompare(b.name);
      })
      .reduce((result, city) => {
        const firstLetter = city.name.charAt(0);
        if (result[firstLetter] === undefined) {
          result[firstLetter] = [];
        }
        result[firstLetter].push(city);
        return result;
      }, {}
    );

    let FilterCities = this.props.cities
      .filter((item) =>  item.name.toLowerCase() === 'удаленная работа' || item.name.toLowerCase() === 'вся россия')

    return (
      <div className={`citiesList ${this.props.modifier ? this.props.modifier : ''} ${this.props.multiply ? 'citiesList--multiply' : ''}`}>
        <div className="container container--paddingVertical container--paddingVertical-top">
          <h2 className="text text--h2 text--center">Выберите город</h2>
          <div className="citiesList__columns--center"> 
            {
              FilterCities.map((c, i) => (
                this.props.multiply ?
                <Checkbox
                  handleCheckboxChange={this.toggleCheckbox}
                  labelPrepositional={c.name_prepositional}
                  label={c.name}
                  id={c.id}
                  checked={this.props.baseCity.baseCityID === c.id && true}
                  modifier="citiesList__item citiesList__item--checkbox"
                  key={`citiesList__item-${i}`}
                /> :
                <a
                  href=""
                  className="citiesList__item"
                  key={`citiesList__item-${i}`}
                  onClick={(e) => this.handleCityClick(e, c.name, c.name_prepositional, c.id, c.phone)}
                >{c.name}</a>
              ))
            }
          </div>
          <div className="citiesList__columns">
            {
              Object.entries(SortingCities)
              .map((city, index) => (
                  <div className="citiesList__group" key={`citiesList__group-${index}`}>
                    <div className="citiesList__title">{city[0]}</div>
                    {
                      city[1].map((c, i) => (
                        this.props.multiply ?
                        <Checkbox
                          handleCheckboxChange={this.toggleCheckbox}
                          labelPrepositional={c.name_prepositional}
                          label={c.name}
                          id={c.id}
                          checked={this.props.baseCity.baseCityID === c.id && true}
                          modifier="citiesList__item citiesList__item--checkbox"
                          key={`citiesList__item-${i}`}
                        /> :
                        <a
                          href=""
                          className="citiesList__item"
                          key={`citiesList__item-${i}`}
                          onClick={(e) => this.handleCityClick(e, c.name, c.name_prepositional, c.id, c.phone)}
                        >{c.name}</a>
                      ))
                    }
                  </div>
                )
              )
            }
          </div>
        </div>
        {
          this.props.multiply &&
          <div className="citiesList__footer container container--grayed container--paddingVertical-xs">
            <div className="row row--verticalCenter">
              <div className="col colMobile--12">
                <a className="citiesList__allCities" href="" onClick={(e) => this.handleAllCitiesClick(e)}>По всей России</a>
              </div>
              <div className="col col--alignRight colMobile--12">
                <Button
                  link="/"
                  text="Показать выбранное"
                  modifier="button--wide-mobile button--marginNot button--xs"
                  onClick={(e) => this.handleCitiesClick(e)}
                />
              </div>
            </div>
          </div>
        }
        {
          (!this.props.multiply && this.props.baseCity && this.props.baseCity.baseCityID) &&
          <div className="citiesList__footer container container--center container--grayed container--paddingVertical-xs">
            <Button
              link="/"
              text="Во всех городах"
              modifier="button--wide-mobile button--marginNot button--xs"
              onClick={(e) => this.handleAllCitiesClick(e)}
            />
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    baseCity: state.baseCity,
    filter: state.filter,
    modal: state.modal.opened,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleCityChange: (baseCityName, baseCityPrepositional, baseCityID, baseCityPhone) => {
      dispatch(setCity(baseCityName))
      if (baseCityPrepositional) {
        dispatch(setCityPrepositional(baseCityPrepositional))
      } else {
        dispatch(setCityPrepositional(baseCityName))
      }
      dispatch(setCityID(baseCityID))
      dispatch(setCityPhone(baseCityPhone))
      dispatch(setFilterData(baseCityID, '', "city"))
      dispatch(setCitySelected(true))
    },
    handleCityClick: (baseCityName, baseCityPrepositional, baseCityID, baseCityPhone) => {
      dispatch(setCity(baseCityName))
      if (baseCityPrepositional) {
        dispatch(setCityPrepositional(baseCityPrepositional))
      } else {
        dispatch(setCityPrepositional(baseCityName))
      }
      dispatch(setCityID(baseCityID))
      dispatch(setCityPhone(baseCityPhone))
      dispatch(setCitySelected(true))
      dispatch(setFilterData(baseCityID, '', "city"))
      dispatch(modalClose())
    },
    handleCitiesClick: (array) => {
      dispatch(setCitySelected(true))
      dispatch(setFilterData(array, '', "city"))
      dispatch(modalClose())
    },
    handleAllCitiesClick: () => {
      dispatch(setFilterData('', '', "city"))
      dispatch(modalClose())
      dispatch(clear())
      dispatch(setCitySelected(true))
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CitiesList));


// WEBPACK FOOTER //
// ./src/components/CitiesList/index.js